var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { HeaderLogo, HeaderLogoSizes } from './header-logo';
var HeaderImageToolbar = /** @class */ (function (_super) {
    __extends(HeaderImageToolbar, _super);
    function HeaderImageToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    HeaderImageToolbar.prototype.render = function () {
        var _a = this.props, headerImg = _a.headerImg, isPoweredBy = _a.isPoweredBy;
        if (!headerImg || !headerImg.sectionData || headerImg.sectionData.length < 1) {
            return null;
        }
        return headerImg.sectionData
            .filter(function (item) { return item && (item.type === 'link' || item.type === 'img'); })
            .map(function (item) {
            var imgSrc = item.imgSrc, text = item.text, url = item.url, id = item.id;
            var logoSize = isPoweredBy ? HeaderLogoSizes.XSMALL : HeaderLogoSizes.LARGE;
            return (React.createElement(Viewport, { key: id },
                React.createElement(ViewSmall, null,
                    React.createElement(HeaderLogo, { logoUrl: imgSrc, logoAltText: text, logoHref: url, logoSize: isPoweredBy ? HeaderLogoSizes.XSMALL : HeaderLogoSizes.SMALL })),
                React.createElement(ViewMedium, null,
                    React.createElement(HeaderLogo, { logoUrl: imgSrc, logoAltText: text, logoHref: url, logoSize: logoSize })),
                React.createElement(ViewLarge, null,
                    React.createElement(HeaderLogo, { logoUrl: imgSrc, logoAltText: text, logoHref: url, logoSize: logoSize }))));
        });
    };
    HeaderImageToolbar = __decorate([
        inject('experiment')
    ], HeaderImageToolbar);
    return HeaderImageToolbar;
}(React.Component));
export { HeaderImageToolbar };
//# sourceMappingURL=header-image-toolbar.js.map